// Motion primitives & tokens for Selling Sunsets.
// Durations (seconds) mirror the design system: micro / fast / editorial / cinematic.
export const DURATION = {
  micro: 0.15,
  fast: 0.3,
  editorial: 0.6,
  cinematic: 1.2,
};

export const EASE = {
  editorial: [0.25, 1, 0.5, 1],
  cinematic: [0.16, 1, 0.3, 1],
  sharp: [0.4, 0, 0.2, 1],
};

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.editorial, ease: EASE.editorial },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: DURATION.editorial, ease: EASE.editorial } },
};

export const maskReveal = {
  hidden: { clipPath: "inset(100% 0 0 0)", opacity: 0.4 },
  show: {
    clipPath: "inset(0% 0 0 0)",
    opacity: 1,
    transition: { duration: DURATION.cinematic, ease: EASE.cinematic },
  },
};

export const stagger = (delayChildren = 0.05, staggerChildren = 0.08) => ({
  hidden: {},
  show: {
    transition: { delayChildren, staggerChildren },
  },
});

// viewport config reused across reveals
export const inView = { once: true, amount: 0.3 };
